import { useThemeContext } from '#contexts/ThemeContext';
import { Box } from '@material-ui/core';

export const Header = () => {
  const { logoBackgroundColor, logo, websiteUrl, defaultPicture } = useThemeContext();
  const logoLink = String(websiteUrl).startsWith('http') ? websiteUrl : `//${websiteUrl}`;

  return (
    <Box
      bgcolor={logoBackgroundColor}
      className='swyft-box-shadow-down'
      height={{ xs: 80, lg: 100 }}
      width='100%'
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      {websiteUrl ? (
        <a href={logoLink} target='_blank' rel='noreferrer' style={{ height: '90%' }}>
          <img src={logo || defaultPicture} alt='Logo' style={{ height: '100%' }} />
        </a>
      ) : (
        <Box height='90%'>
          <img src={logo || defaultPicture} alt='Logo' style={{ height: '100%' }} />
        </Box>
      )}
    </Box>
  );
};
